// extracted by mini-css-extract-plugin
export var sketch = "Sketch-module--sketch--1jtFN";
export var sketchPrimary = "Sketch-module--sketch--primary--qyEXu";